import type { SurveyPresetTemplateData, SurveyQuestionData, SurveyTemplateQuestion } from './firebase';

export function surveyHasTextQuestions(
  selectedQuestions: SurveyTemplateQuestion[],
  questions: SurveyQuestionData[],
): boolean {
  return selectedQuestions.some(selected =>
    questions.some(question => question.id === selected.questionId && question.inputType === 'text'),
  );
}

/** Normalize both new and legacy templates before displaying or saving settings. */
export function getSurveyTemplateSettings(
  template: Pick<SurveyPresetTemplateData, 'questions' | 'displayType' | 'commsEnabled'>,
  questions: SurveyQuestionData[],
) {
  return {
    promptType: 'passive' as const,
    percentageOfWorkforce: 100 as const,
    displayType: surveyHasTextQuestions(template.questions, questions) || template.displayType === 'wizard'
      ? 'wizard' as const
      : 'inline' as const,
    commsEnabled: template.commsEnabled === 'email' ? 'email' as const : 'none' as const,
  };
}